<div *ngIf="isMobile; else webLogin" class="full-container">
  <div class="update-container">
    <div class="top-content">
      <div class="bid-info-mobile">
        <div class="instruction-mobile">
          Please update your Bid and Submit
        </div>
      </div>
      <div class="form-container-mobile">
        <form [formGroup]="modalForm">
          <div class="bid-form-box">
            <div class="form-group-mobile">
              <div class="form-label-mobile">Enter Number of Units (Kwh)</div>
              <input type="text" inputmode="decimal" id="energy_amount" class="form-control-mobile" appOnlyDecimalNumber formControlName="energy_amount" pattern="^\d+(\.\d{1,2})?$">
              <div *ngIf="energy_amount?.invalid && (energy_amount?.dirty || energy_amount?.touched)">
                <div class="error-mobile" *ngIf="energy_amount?.errors?.['required']">
                  Energy is required.
                </div>
                <div class="error-mobile" *ngIf="!energy_amount?.errors?.['nonNegative'] && energy_amount?.errors?.['min']">
                  Energy must be greater than 0.
                </div>
              </div>
            </div>
            <div class="form-group-mobile">
              <div class="form-label-mobile">Enter Bid rate (Rs.)</div>
              <input type="text" inputmode="decimal" id="bidPrice" class="form-control-mobile" appOnlyDecimalNumber formControlName="bidPrice" pattern="^\d+(\.\d{1,2})?$">
              <div *ngIf="bidPrice?.invalid && (bidPrice?.dirty || bidPrice?.touched)">
                <div class="error-mobile" *ngIf="bidPrice?.errors?.['required']">
                  Bid Price is required.
                </div>
                <div class="error-mobile" *ngIf="!bidPrice?.errors?.['nonNegative'] && bidPrice?.errors?.['min']">
                  Bid price must be greater than 0.
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="bottom-content">
      <div class="cancel-and-submit-buttons">
        <div class="cancel-button-mobile">
            <button (click)="onCancel()">Cancel</button>
        </div>
        <div class="submit-button-mobile">
            <button type="submit" (click)="submitBid()" type="submit" [disabled]="!modalForm.valid">Submit</button>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #webLogin>
<div class="registration-container">
    <div class="form-container">
      <div class="form-header">Update Current Bid</div>
      <div *ngIf="isLoading" class="loading-web">
        Updating bid, please wait...
      </div>
      <form [formGroup]="modalForm">
        <div class="form-group">
         <div class="form-field">
            <label for="bidPrice">Bid Price</label>
            <input type="text" inputmode="decimal" id="bidPrice" class="form-control-mobile" appOnlyDecimalNumber formControlName="bidPrice" pattern="^\d+(\.\d{1,2})?$">
            <div *ngIf="bidPrice?.invalid && (bidPrice?.dirty || bidPrice?.touched)">
              <div class="error" *ngIf="bidPrice?.errors?.['required']">
                Bid Price is required.
              </div>
              <div class="error" *ngIf="!bidPrice?.errors?.['nonNegative'] && bidPrice?.errors?.['min']">
                Bid price must be greater than 0.
              </div>
              <div class="error" *ngIf="bidPrice?.errors?.['nonNegative']">
                Bid Price must be a non-negative number.
              </div>
            </div>
          </div>

          <div class="form-field">
            <label for="energyAmt">Energy Amount</label>
            <input type="text" inputmode="decimal" id="energyAmt" class="form-control-mobile" appOnlyDecimalNumber formControlName="energy_amount" pattern="^\d+(\.\d{1,2})?$">
            <div *ngIf="energy_amount?.invalid && (energy_amount?.dirty || energy_amount?.touched)">
              <div class="error" *ngIf="energy_amount?.errors?.['required']">
                Energy Amount is required.
              </div>
              <div class="error" *ngIf="!energy_amount?.errors?.['nonNegative'] && energy_amount?.errors?.['min']">
                Energy Amount must be greater than 0.
              </div>
            </div>
          </div>

        </div>      
      </form>
      <div class="form-actions">
        <button type="button" (click)="onCancel()" [disabled]="isLoading">Cancel</button>
        <button (click)="submitBid()" type="submit" [disabled]="!modalForm.valid || isLoading">Submit</button>
      </div>
    </div>
  </div>
</ng-template>

